import React from 'react';
import { SimilarProposerFileField } from '@composite/similar-files/similar-proposer-file-field';

export function SimilarFilesFields() {
  return <SimilarProposerFileField />;
}
